import moment from "moment";
import Cookies from "js-cookie";
import { useContext, useState } from "react";
import { RxCrossCircled } from "react-icons/rx";
import { Avatar, Box, Modal, Stack } from "@mui/material";
import { AdminDashboardContext, MyContext } from "src/components/Context/MyContext";

const ClientAvatar = ({ avHeight, radius = "" }) => {
  const roleId = Cookies.get("roleId");
  const { selectedChat,userId } = useContext(MyContext);
  const { lastseen, somebodyIsTyping, otherSide_status } = useContext(AdminDashboardContext);
  const showChat = JSON.parse(localStorage.getItem("showChat"));

  const [openUserProfile, setOpenUserProfile] = useState(false);

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ marginLeft: "20px" }}>
        <Avatar
          alt="Remy Sharp"
          src={selectedChat?.imageurl}
          onClick={() => setOpenUserProfile(true)}
          sx={{
            borderRadius: `${radius}`,
            height: `${avHeight}`,
            width: `${avHeight}`,
            cursor: "pointer",
          }}
        />
        <div className="flex flex-col justify-center">
          <h2 className="text-[16px] font-medium leading-6 text-black">{selectedChat?.username}</h2>

          {somebodyIsTyping?.status && (String(somebodyIsTyping.subscriptionID) == String(showChat?._id) && somebodyIsTyping.reciverId.includes(userId) || roleId == "1") ? (
            <p className="text-[#858585] text-xs font-medium mt-2">typing...</p>
          ) : (
            <p className="text-[#858585] text-xs font-medium mt-2">
              {otherSide_status == "leave" ? (lastseen != null || "" ? `Last seen ${moment(lastseen).fromNow()}` : "") : otherSide_status == "join" ? "online" : null}
            </p>
          )}
        </div>
      </Stack>
      {openUserProfile ? (
        <Modal
          open={openUserProfile}
          onClose={() => setOpenUserProfile(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          }}
        >
          <Box
            sx={{
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              // backgroundColor: "black",
            }}
          >
            <RxCrossCircled
              size={30}
              className="absolute right-2 top-2 cursor-pointer bg-gray-200 rounded-full"
              onClick={() => {
                setOpenUserProfile(false);
              }}
            />
            <img src={selectedChat?.imageurl} alt="User Profile" className="rounded-full object-cover h-[500px] w-[500px]" />
          </Box>
        </Modal>
      ) : null}
    </>
  );
};

export default ClientAvatar;
